import script from "./WebinarReplayVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarReplayVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./WebinarReplayVideoPlayer.vue?vue&type=style&index=0&id=1f590cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f590cae"]])

export default __exports__